/* Live prices for shop_pseudo_product cards on listing pages (collection grid, rails,
   related, shop landing). These products carry no price of their own: the price lives on
   the price_class products and is resolved per Spec 5 at read time. Each [data-bnx-cp]
   element holds the comma-joined cloud_product ids; we resolve them via the app proxy,
   sum qty x price_class variant price from the Liquid-rendered (Markets-localised)
   priceMap and write the formatted amount in. Logged-in owners see their remaining
   delta; fully-owned packs show the localized owned label. One resolver call per unique
   cp set, shared across cards. */
(function () {
  if (window.__beneosCardPrice) return;
  window.__beneosCardPrice = true;

  var cache = {}; // one resolver call per unique cp set, shared across scans

  function init() {
    var dataEl = document.querySelector('.beneos-cardprice-data');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    // Re-scannable for client-rendered cards (fresh rail): already priced
    // elements are marked and skipped.
    var els = document.querySelectorAll('[data-bnx-cp]:not([data-bnx-priced])');
    if (!els.length) return;

    var B = window.Beneos || {};
    var priceMap = cfg.priceMap || {};
    var proxyUrl = cfg.proxyUrl || '/apps/beneos/library';

    function numId(gid) { return String(gid == null ? '' : gid).replace(/\D/g, ''); }
    function money(cents) {
      if (B.cart && typeof B.cart.formatMoney === 'function') return B.cart.formatMoney(cents);
      return (Math.round(cents) / 100).toFixed(2);
    }

    els.forEach(function (el) {
      var cp = el.getAttribute('data-bnx-cp');
      if (!cp) return;
      el.setAttribute('data-bnx-priced', '1');
      if (!cache[cp]) {
        cache[cp] = fetch(proxyUrl + '?resource=resolve&cp=' + encodeURIComponent(cp), {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        }).then(function (r) { return r.json(); });
      }
      cache[cp].then(function (j) {
        var d = (j && j.data) || {};
        var groups = d.groups || [];
        if (!groups.length) {
          if ((d.total_uploads || 0) > 0) {
            el.textContent = cfg.owned || 'Owned';
            el.classList.add('bnx-owned');
          }
          return;
        }
        var total = 0, ok = true;
        groups.forEach(function (g) {
          var p = priceMap[numId(g.variant_id)];
          if (p == null) { ok = false; return; }
          total += p * (g.qty || 0);
        });
        if (!ok) return;
        // Bundle discount: strike the full (regular-class) sum next to the live price.
        var fullTotal = 0, fullOk = !!(d.bundle_pricing && (d.full_groups || []).length);
        (d.full_groups || []).forEach(function (g) {
          var p = priceMap[numId(g.variant_id)];
          if (p == null) { fullOk = false; return; }
          fullTotal += p * (g.qty || 0);
        });
        if (fullOk && fullTotal > total) {
          el.innerHTML = '';
          el.appendChild(document.createTextNode(money(total) + ' '));
          var s = document.createElement('s');
          s.style.opacity = '.55';
          s.style.fontSize = '.85em';
          s.textContent = money(fullTotal);
          el.appendChild(s);
        } else {
          el.textContent = money(total);
        }
      }).catch(function () {}); // network fail: keep the placeholder, never show a wrong price
    });
  }

  window.BeneosCardPrice = { scan: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
